import { getOperatorOptions } from '../logicHelpers'

const jsdataSource = () => ({
  types: [
    { label: 'JavaScript Variable', value: 'windowVariable', description: 'A value your page sets in JavaScript' },
    { label: 'Cookie', value: 'cookie', description: "A cookie in the visitor's browser" },
    { label: 'Local Storage', value: 'localStorage', description: "A value saved in the visitor's browser" }
  ],
  inputs: [
    {
      control: 'text',
      key: 'jsdata-variable-input',
      name: 'variable',
      placeholder: 'mydata.industry',
      can: (condition: { $source: string; $type: string }) => condition.$source === 'jsdata'
    },
    {
      control: 'select',
      key: 'jsdata-operator-select',
      id: 'operator',
      name: 'operator',
      options: getOperatorOptions(),
      can: (condition: { $source: string; $type: string }) => condition.$source === 'jsdata'
    },
    {
      control: 'text',
      key: 'jsdata-value-input',
      name: 'value',
      can: (condition: { $source: string; $type: string; operator: string }) =>
        condition.$source === 'jsdata' && condition.operator !== 'is set' && condition.operator !== 'is not set'
    }
  ]
})

export default jsdataSource
